import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function PlayOutlineIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 256 256" {...props}>
      <Box as="rect" width="256" height="256" fill="none" />
      <Box
        as="circle"
        cx="128"
        cy="128"
        r="96"
        fill="none"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeWidth="16"
      />
      <Box
        as="polygon"
        points="160 128 112 96 112 160 160 128"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
      />
    </Icon>
  );
}
